import { Outlet, useLocation, useRouteError, useRouteLoaderData } from 'react-router';
import { captureException } from '@sentry/react-router';

import RootErrorPage, {
  DEFAULT_RESOURCES_URL,
  extractException,
} from '~/vendor/cx-web/components/composites/RootErrorPage';
import { getRepubFromURL, isErrorWithStatus } from '~/vendor/cx-web/utils';

import { type loader } from './root-loader';

export { loader } from './root-loader';

export function ErrorBoundary() {
  const error = useRouteError();
  captureException(extractException(error));

  const rootLoaderData = useRouteLoaderData<typeof loader>('root');
  const location = useLocation();
  const repub = rootLoaderData?.repub ?? getRepubFromURL(new URL(`https://www.oddschecker.com${location.pathname}`));
  const errorStatus = isErrorWithStatus(error) ? error.status : null;

  return (
    <RootErrorPage
      errorStatus={errorStatus}
      repub={repub}
      resourcesUrl={rootLoaderData?.resourcesUrl ?? DEFAULT_RESOURCES_URL}
    />
  );
}

function App() {
  return <Outlet />;
}

export default App;
